import { IUserDefinedItemSelectBehavior, ILinkedObjectSpecifiable } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { instanceOfIPresentableLinkedObjectIdentifier } from "./IPresentableLinkedObjectIdentifier";

export interface IUserDefinedItemSelectBehaviorPropertyEditable {
  userDefinedItemSelectBehavior(): IPropertyEditable<IUserDefinedItemSelectBehavior>;
  toLinkedObjectIdentifier(): ILinkedObjectSpecifiable;
}

export function instanceOfIUserDefinedItemSelectBehaviorPropertyEditable(instance: any): instance is IUserDefinedItemSelectBehaviorPropertyEditable {
  return instance
      && instance.userDefinedItemSelectBehavior
      && instanceOfIPropertyEditable<IUserDefinedItemSelectBehavior>(instance.userDefinedItemSelectBehavior())
      && instanceOfIPresentableLinkedObjectIdentifier(instance);
}
